module.exports = __webpack_public_path__ + "static/media/pla_dea_man_han.35a77225.png";